<template>
  <component
    :is="chartTypeComponent"
    :data="data"
    :ytitle="trans('statistic.count')"
    :dataset="{borderWidth: 0}"
    :colors="colorsInternal"
    v-bind="$attrs"
    :library="completeOptions"
    ref="chartComponent"
  ></component>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import merge from 'deepmerge';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

export default {
  name: 'SurveyChart',
  mixins: [
    LocaleUtils
  ],
  props: {
    data: null,
    chartType: {
      default: 'column'
    },
    showLegend: {
      default () {
        return this.chartType === 'pie';
      }
    },
    options: null,
    colors: null
  },
  computed: {
    chartTypeComponent () {
      switch (this.chartType) {
        case 'column':
        case 'bar':
        case 'line':
        case 'pie':
          return this.chartType.toLowerCase()+'-chart';
        default:
          return 'column-chart';
      }
    },
    colorsInternal () {
      let colors = null;

      if (this.colors) {
        return this.colors;
      }

      if (this.data && Chartkick.options.colors) {
        colors = [];
        for (let i = 0; i < this.data.length; i++) {
          colors.push(Chartkick.options.colors[i % Chartkick.options.colors.length]);
        }
      }

      return colors;
    },
    completeOptions () {
      let self = this;

      const defaultOptions = {
        layout: {
          padding: {
            top: this.chartType === 'pie' ? 10 : 25
          }
        },
        animation: {
          animateRotate: true
        },
        legend: {
          display: this.showLegend,
          position: 'bottom'
        },
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0;
              let dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
              let label = '';
              if (sum > 0) {
                if (this.chartType === 'pie') {
                  if (value > 0) {
                    label = Math.round(value * 100 / sum) + '%';
                  }
                } else {
                  label = value;
                }
              }
              return label;
            },
            color: '#666',
            offset: 4,
            font: {
              weight: 'bold'
            },
            anchor: 'end',
            align: 'end'
          }
        },
        onClick (event) {
          let chart = self.$refs.chartComponent.chart.chart;
          // console.debug('onClick chart', chart);
          if (chart) {
            let canvasPosition = Chart.helpers.getRelativePosition(event, chart);
            let chartElements = chart.getElementsAtEvent(event);
            if (chartElements && chartElements[0]) {
              // For pie charts
              // console.log('chartElements[0]._index', chartElements[0]._index);
              self.$emit('click-x-axis', chartElements[0]._index);
            } else if (chart.scales['x-axis-0']) {
              let dataX = chart.scales['x-axis-0'].getValueForPixel(canvasPosition.x);
              self.$emit('click-x-axis', dataX);
            }
          }
        }
      };

      let moreOptions = {};
      if (this.chartType === 'pie') {
        moreOptions.plugins = {
          datalabels: {
            color: '#fff',
            anchor: 'center',
            align: 'end',
          }
        }
      }

      return merge.all([{}, defaultOptions, moreOptions, this.options || {}]);
    }
  }
}
</script>

<style scoped>

</style>
